export default __webpack_public_path__ + "static/media/flying-robot.2ff18b96.png";